export const mutations = {

  // ~768 手机; 768 - 1280 中屏; >=1280 大屏
  screenWidthChange (state) {
    let screenWidth = document.documentElement.clientWidth;
    state.screenWidth = screenWidth;
    if ( screenWidth < 768 ) {
      state.screenType = 0;
    } else if ( screenWidth < 1280 ) {
      state.screenType = 1;
    } else {
      state.screenType = 2;
    }
  },

  changeIndex (state, data) {
    state.menuIndex = data.linkName;
  },

  login (state, data) {
    state.isLogin = true;
    state.userData = data;
  },

  updateAlbum (state, data) {
    state.album.isCreated = true;
    state.album.page = data.page;
    state.album.isAll = data.isAll;
    state.album.images = state.album.images.concat(data.imageList);
  },

  updateBlog (state, data) {
    state.blog.isCreated = true;
    state.blog.page = data.page;
    state.blog.isAll = data.isAll;
    state.blog.blogList = state.blog.blogList.concat(data.blogList);
  },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js